<div class="global-alert">
  <div class="global-alert__content">
    <div class="global-alert__content-left">
      <div class="global-alert__content-left-icon">
        <fr8bot-ui-icon [name]="iconName()" [size]="32" />
      </div>

      @if (title()) {
        <div class="global-alert__content-left-text">
          <div class="global-alert__content-left-text-title">{{ title() }}</div>

          @if (description()) {
            <div class="global-alert__content-left-text-description">
              {{ description() }}
            </div>
          }
        </div>
      }
    </div>

    <div class="global-alert__content-right">
      <ng-content select="[alert-actions]" />
    </div>
  </div>
</div>
